import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { AccountApplicantsDTO } from './useAccountApplicantsQuery';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';

interface UpdateAccountParams {
  clientId: string;
  accountInfo: AccountApplicantsDTO;
  managedAccountId: string;
  accountId: string;
}

const updateAccount = ({
  clientId,
  accountInfo,
  managedAccountId,
  accountId,
}: UpdateAccountParams) => {
  return authFetch('/Consumer/ManagedAccounts/UpdateAccountInformation', {
    method: 'POST',
    ...httpBodyOptions(
      {
        clientId,
        managedAccountId,
        accountId,
        ...accountInfo,
      },
      true,
    ),
  });
};

export const useUpdateAccountMutation = () => {
  return useMutation(updateAccount);
};
